import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { OrganizationMember } from "@/lib/api/betterAuth";
import { CustomerAssignmentEditor } from "./CustomerAssignmentEditor";

interface CustomerAssignmentModalProps {
  open: boolean;
  onClose: () => void;
  member?: OrganizationMember;
  relationType: "risk" | "freight";
  maxAllowed?: number;
}

export function CustomerAssignmentModal({
  open,
  onClose,
  member,
  relationType = "risk",
  maxAllowed,
}: CustomerAssignmentModalProps) {
  if (!member) return null;

  const modalTitle = relationType === "freight" 
    ? "Assign Freight Customer"
    : "Assign Risk Customers";

  return (
    <Dialog open={open} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-2xl max-h-[80vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>{modalTitle}</DialogTitle>
          <p className="text-sm text-gray-600">
            {member.authuser?.name || "Unknown User"}
          </p>
        </DialogHeader>

        <CustomerAssignmentEditor
          member={member}
          relationType={relationType}
          onSuccess={onClose}
          inline={false}
          maxAllowed={maxAllowed}
        />
      </DialogContent>
    </Dialog>
  );
}

